export const root = "rut42l0";
export const pill = "pfsz1jz";
export const label = "lnd6h4m";
export const secondary = "s1qw4clm";
export const primary = "p1r5ku5l";
export const tertiary = "t1et3kbb";
export const grey = "g10qxvo6";

require("./style.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");